import type { DeepRequired } from 'utility-types';

import type { ApiComponentType } from '../types';

export enum ApiRole {
  Citizen = 'CITIZEN',
  Notary = 'NOTARY',
  Collaborator = 'COLLABORATOR',
}

export enum ApiAccessLevel {
  NotRegistered = 0,
  NotConfirmed = 1,
  Confirmed = 2,
}

export enum ApiPushNotificationsStatus {
  NotDetermined = 'NOT_DETERMINED',
  Authorized = 'AUTHORIZED',
  Denied = 'DENIED',
}

export interface ApiUser extends Required<Omit<ApiComponentType<'UserDetails'>, 'nrn'>> {
  accessLevel: ApiAccessLevel;
  pushNotificationsStatus: ApiPushNotificationsStatus;
  roles: ApiRole[];
  nrn?: string;
}

export interface ApiMarkDeceasedValues {
  nrn: string;
  deceasedNotificationDate: string;
  deceasedDate: string;
}

export interface ApiUserMailConfiguration {
  subscriptions?: DeepRequired<ApiComponentType<'UserSubscription'>>[];
}

export type ApiUserFrontendSyncConfiguration = ApiComponentType<'UserFrontendSyncConfiguration'>;

export type MailConfigurationEvent = ApiComponentType<'UserEventType'>;
